import {Injectable} from '@angular/core';
import {MenuItem} from '../model/MenuItem';
import {UrlHelper} from '../helper/url.helper';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MenuProviderService {

  constructor(private authService: AuthService) {
  }

  public async mainMenu(): Promise<MenuItem[]> {
    const session = await this.authService.getSession();

    const menu: MenuItem[] = [];

    if (session.isValid()) {
      if (session.isParticipant()) {
        menu.push(new MenuItem(
          $localize`:Navigation|Contests label@@navigation-contests-label:Contests`,
          'contests-icon', UrlHelper.CONTESTS_AVAILABLE_PATH, true));
      } else if (!session.isAdmin()) {
        menu.push(new MenuItem(
          $localize`:Navigation|Information label@@navigation-information-label:Information`,
          'competitions-icon', UrlHelper.COMPETITIONS_DETAILS_PATH, true));
      }

      if (session.isAdmin()) {
        menu.push(new MenuItem(
          $localize`:Navigation|Competitions label@@navigation-competitions-label:Competitions`,
          'competitions-icon', UrlHelper.COMPETITIONS_LIST_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Hosts label@@navigation-hosts-label:Hosts`,
          'hosts-icon', UrlHelper.HOSTS_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Contests label@@navigation-contests-label:Contests`,
          'contests-icon', UrlHelper.CONTESTS_AVAILABLE_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Migrations title@@navigation-migrations-title:Migrations`,
          'migrations-icon', UrlHelper.MIGRATIONS_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Settings title@@navigation-settings-dashboard-title:Settings`,
          'settings-icon', UrlHelper.SETTINGS_SCHOOLS_PATH, true));


      } else if (session.isHost()) {
        menu.push(new MenuItem(
          $localize`:Navigation|Stats label@@navigation-stats-label:Statistics`,
          'stats-icon', UrlHelper.STATS_CONTEST_PART_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Contests label@@navigation-contests-label:Contests`,
          'contests-icon', UrlHelper.CONTESTS_MANAGE_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Coordinators label@@navigation-coordinators-label:Coordinators`,
          'coordinators-icon', UrlHelper.COORDINATORS_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Teachers label@@navigation-teachers-label:Teachers`,
          'teachers-icon', UrlHelper.TEACHERS_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Students label@@navigation-students-label:Students`,
          'students-icon', UrlHelper.STUDENTS_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Settings title@@navigation-settings-dashboard-title:Settings`,
          'settings-icon', UrlHelper.SETTINGS_SCHOOLS_PATH, true));


      } else if (session.isCoordinator()) {
        menu.push(new MenuItem(
          $localize`:Navigation|Stats label@@navigation-stats-label:Statistics`,
          'stats-icon', UrlHelper.STATS_CONTEST_PART_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Teachers label@@navigation-teachers-label:Teachers`,
          'teachers-icon', UrlHelper.TEACHERS_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Students label@@navigation-students-label:Students`,
          'students-icon', UrlHelper.STUDENTS_PATH, true));


      } else if (session.isTeacher()) {
        menu.push(new MenuItem(
          $localize`:Navigation|Results label@@navigation-results-label:Results`,
          'stats-icon', UrlHelper.STATS_EXAM_RATING_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Contests label@@navigation-contests-label:Contests`,
          'contests-icon', UrlHelper.CONTESTS_HISTORY_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Students label@@navigation-students-label:Students`,
          'students-icon', UrlHelper.STUDENTS_PATH, true));


      } else if (!session.isParticipant()) {
        menu.push(new MenuItem(
          $localize`:Navigation|Results label@@navigation-results-label:Results`,
          'stats-icon', UrlHelper.STATS_EXAM_RATING_PATH, true));
        menu.push(new MenuItem(
          $localize`:Navigation|Contests label@@navigation-contests-label:Contests`,
          'contests-icon', UrlHelper.CONTESTS_HISTORY_PATH, true));
      }
    }

    return menu;
  }

  public supportMenu(): MenuItem[] {
    return [
      new MenuItem(
        $localize`:Navigation|Help label@@navigation-help-label:Help`,
        'help-icon', UrlHelper.SUPPORT_PATH, true),
    ];
  }
}
